import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller, useWatch } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import {
  allTestType,
  allTestedBy,
  AllTestMethod,
  allSampleManagement,
} from "../../../../../../../../features/admin/common/Slice";
import Select from "react-select";

import Common_Back_Btn from "../../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Refresh_btn from "../../../../../../../../common/common_btn/refresh_btn/Refresh_btn";
import Success_Toster from "../../../../../../../../common/common_modal/success_toster/Success_Toster";

import {
  GetSingle,
  Update,
  GetAll,
} from "../../../../../../../../features/admin/quality_management/process_requirement/validity/Slice";

import { formatDateForInput } from "../../../../../../../../utils/common";
import { useFieldArray } from "react-hook-form";

function Retesting_Testing_Edit_Offcanvas({ show, handleClose, id ,validityTypeId}) {
  const dispatch = useDispatch();
  const [removedFiles, setRemovedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showError, setShowError] = useState(null);

  const [companiesPreview, setCompaniesPreview] = useState(null);
  const [attachPreview, setAttachPreview] = useState(null);

  const all_sample_management = useSelector(
    (state) => state.common.all_sample_management,
  );
  const all_tested_by = useSelector((state) => state.common.all_teseted_by);

  const all_test_type = useSelector((state) => state.common.all_test_type);
  const all_test_method = useSelector((state) => state.common.all_test_method);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  const observations = useWatch({
    control,
    name: "observations",
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "observations",
  });

  useEffect(() => {
    dispatch(allSampleManagement());
    dispatch(allTestType());
    dispatch(allTestedBy());
    dispatch(AllTestMethod());
  }, [dispatch]);

  useEffect(() => {
    if (!observations || observations.length === 0) return;

    const values = observations
      .map((o) => parseFloat(o.value))
      .filter((v) => !isNaN(v));

    const avg =
      values.length > 0
        ? (values.reduce((a, b) => a + b, 0) / values.length).toFixed(2)
        : "";

    setValue("average", avg);
  }, [observations, setValue]);

  /* ---------------- GET SINGLE ---------------- */
  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));

      if (res.meta?.requestStatus === "fulfilled") {
        const data = res.payload.message;

        // observations
        const observationsData =
          data?.Validity_Type_Record_Observations?.length > 0
            ? data.Validity_Type_Record_Observations.map((o) => ({
                value: o.observation_value,
              }))
            : [{ value: "" }];

        //RESET FIRST
        reset({
          average: data.average || "",
          attach_file: data?.attach_file || null,
          test_method_id: data.test_method_id || null,
          test_type_id: data.test_type_id || null,
          sample_management_id: data.sample_id || null,
          tested_by_id: data?.tested_by_id || null,
          certified_value: data.certified_value || "",
          remark: data.remark || "",
        });

        // replace
        replace(observationsData);

        //FILE
        if (data.attach_file) {
          setValue("attach_file", data.attach_file);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (
      show &&
      id &&
      all_test_type?.length &&
      all_sample_management?.length &&
      all_tested_by?.length &&
      all_test_method?.length
    ) {
      GetData(id);
    }
  }, [
    show,
    id,
    all_test_type,
    all_sample_management,
    all_tested_by,
    all_test_method,
  ]);

  /* ---------------- SUBMIT ---------------- */
  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      formData.append("user_id", data.user_id);
      formData.append("sample_id", data.sample_management_id);
      formData.append("test_type_id", data.test_type_id);
      formData.append("test_method_id", data.test_method_id);
      formData.append("tested_by_id", data.tested_by_id);
      formData.append("certified_value", data.certified_value);
      formData.append("average", data.average);
      formData.append("remark", data.remark);

      // observations
      data.observations.forEach((o, i) => {
        formData.append(`observations[${i}]`, o.value);
      });

      if (data.attach_file && typeof data.attach_file !== "string") {
        if (data.attach_file.length > 0) {
          formData.append("attach_file", data.attach_file[0]);
        }
      }

      const res = await dispatch(Update({ id, sendData: formData }));

      if (res.meta?.requestStatus === "fulfilled") {
        setSuccess(true);
       await dispatch(GetAll({ validity_type_id: validityTypeId }));

        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 1500);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /* ---------------- AUTO HIDE SUCCESS ---------------- */
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleRemoveCompanies = () => {
    setCompaniesPreview(null);
    setValue("attach_file", null);
    setRemovedFiles((prev) =>
      prev.includes("attach_file") ? prev : [...prev, "attach_file"],
    );
  };

  const handleRemoveAttach = () => {
    setAttachPreview(null);
    setValue("training_certificate", null);
    setRemovedFiles((prev) =>
      prev.includes("training_certificate")
        ? prev
        : [...prev, "training_certificate"],
    );
  };

  return (
    <Offcanvas
      className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit Retesting Testing
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Test Type</Form.Label>
                  <Controller
                    name="test_type_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Test Type is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_test_type}
                        value={
                          all_test_type?.find((o) => o.value === field.value) ||
                          null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.test_type_id && (
                    <span className="text-danger">
                      {errors.test_type_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Sample Id</Form.Label>
                  <Controller
                    name="sample_management_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Sample is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_sample_management}
                        value={
                          all_sample_management?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.sample_management_id && (
                    <span className="text-danger">
                      {errors.sample_management_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Tested By</Form.Label>
                  <Controller
                    name="tested_by_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Tested By is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_tested_by}
                        value={
                          all_tested_by?.find((o) => o.value === field.value) ||
                          null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.tested_by_id && (
                    <span className="text-danger">
                      {errors.tested_by_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Test Method</Form.Label>
                  <Controller
                    name="test_method_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Tested By is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_test_method}
                        value={
                          all_test_method?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.test_method_id && (
                    <span className="text-danger">
                      {errors.test_method_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Certified Value</Form.Label>
                  <Form.Control
                    {...register("certified_value", {
                      required: "Certified Value is required",
                    })}
                  />
                  {errors.certified_value && (
                    <span className="text-danger">
                      {errors.certified_value.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Remark</Form.Label>
                  <Form.Control
                    {...register("remark", {
                      required: "Remark is required",
                    })}
                  />
                  {errors.remark && (
                    <span className="text-danger">{errors.remark.message}</span>
                  )}
                </Form.Group>
              </div>

              {/* Observations */}
              <div className="row mt-3">
                {fields.map((field, index) => (
                  <div key={field.id} className="col-xl-2 col-lg-4 col-md-4">
                    <div className="observation_box">
                      <div className="obs_label">
                        OBS {String(index + 1).padStart(2, "0")}
                      </div>

                      <Form.Control
                        {...register(`observations.${index}.value`, {
                          required: "Observation is required",
                        })}
                      />

                      {errors.observations?.[index]?.value && (
                        <small className="text-danger">
                          {errors.observations[index].value.message}
                        </small>
                      )}

                      {fields.length > 1 && (
                        <button type="button" onClick={() => remove(index)}>
                          ❌
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <button type="button" onClick={() => append({ value: "" })}>
                Add Observation
              </button>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Average</Form.Label>
                  <Form.Control
                    {...register("average", {
                      required: "Average is required",
                    })}
                    readOnly
                  />
                  {errors.average && (
                    <span className="text-danger">
                      {errors.average.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              {/* Attach File */}
              <div className="col-md-7">
                <Form.Group className="form_group file_field">
                  <Form.Label>Attached File</Form.Label>
                  <Form.Control
                    type="file"
                    {...register("attach_file", {
                      // validate: (value) => {
                      //   if (typeof value === "string") return true; // existing file
                      //   if (value && value.length > 0) return true; // new file
                      //   return "File is required";
                      // },
                    })}
                    accept="*"
                  />
                  {errors.attach_file && (
                    <span className="text-danger">
                      {errors.attach_file.message}
                    </span>
                  )}
                  {(() => {
                    const fileValue = watch("attach_file");

                    //handle string (existing file)
                    let fileUrl = null;

                    if (typeof fileValue === "string" && fileValue) {
                      fileUrl = process.env.REACT_APP_IMG_URL + fileValue;
                    }

                    //handle FileList (new upload)
                    else if (fileValue && fileValue.length > 0) {
                      fileUrl = URL.createObjectURL(fileValue[0]);
                    }

                    // detect type
                    const fileType =
                      typeof fileValue === "string"
                        ? fileValue.toLowerCase()
                        : fileValue?.[0]?.type;

                    if (!fileUrl) return null;

                    return (
                      <div className="image_holder mt-2">
                        {(fileType?.includes("image") ||
                          fileType?.endsWith(".jpg") ||
                          fileType?.endsWith(".jpeg") ||
                          fileType?.endsWith(".png")) && (
                          <img
                            src={fileUrl}
                            alt="Preview"
                            className="img_preview"
                          />
                        )}

                        {/* PDF */}
                        {(fileType === "application/pdf" ||
                          fileType?.endsWith(".pdf")) && (
                          <iframe
                            src={fileUrl}
                            style={{ maxWidth: "100px" }}
                            title="PDF"
                            className="img_preview"
                          />
                        )}

                        {/* WORD */}
                        {(fileType?.includes("word") ||
                          fileType?.endsWith(".doc") ||
                          fileType?.endsWith(".docx")) && (
                          <div>
                            <p>Word preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Word File
                            </a>

                            <iframe
                              src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                              style={{ maxWidth: "100px" }}
                              title="Word Preview"
                              className="img_preview"
                            />
                          </div>
                        )}

                        {/* EXCEL */}
                        {(fileType?.includes("spreadsheet") ||
                          fileType?.endsWith(".xlsx") ||
                          fileType?.endsWith(".xls")) && (
                          <div className="img_preview">
                            <p>Excel preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Excel File
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                  {/* <div className="image_holder">
                                  <img
                                    src={
                                      companiesPreview ||
                                      "/assets/images/other/dummy-image.png"
                                    }
                                    className="img_preview"
                                    alt=""
                                  />
                                  {companiesPreview && (
                                    <FontAwesomeIcon
                                      icon={faTrashCan}
                                      className="delete_icon"
                                      onClick={handleRemoveCompanies}
                                    />
                                  )}
                                </div> */}
                </Form.Group>
              </div>
            </div>
          </div>

          <div className="offcanvas_footer_holder">
            {success ? (
              <Success_Toster successText="Updated Successfully!" />
            ) : (
              <>
                <div className="btns_holder">
                  <Gray_Btn btnText="Cancel" onClick={handleClose} />
                  <Black_Submit_Btn btnText="Submit" type="submit" />
                </div>
                {/* <Refresh_btn /> */}
              </>
            )}
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Retesting_Testing_Edit_Offcanvas;
